/**
 * P3-32: Ziggurat 升级按钮（ZigguratBtnController / BuildingStackableBtn）。
 */
import { useZigguratButtonModel } from "./useReligionModel";
import { StackableButton } from "../../components/StackableButton";

interface ZigguratUpgradeButtonProps {
  upgradeName: string;
}

export function ZigguratUpgradeButton({ upgradeName }: ZigguratUpgradeButtonProps) {
  const { snap, modelRef, controller, getTooltip } = useZigguratButtonModel(upgradeName);

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <StackableButton
      snap={snap}
      controller={controller}
      getModel={() => modelRef.current}
      getTooltip={getTooltip}
    />
  );
}
